import React from 'react'
import { Link } from 'react-router-dom'

export default function SweetPotato() {
  return <>
    <div className="container-fluid bg-primary py-5 bg-prd15 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Fresh sweet potato
            </h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Fresh sweet potato
            </Link>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-5">
      <div className='mb-5'>
        <h2 className='text-primary'> Fresh sweet potato
        </h2>
        <h5 className='text-muted'>Sweet potatoes are nutritious and delicious root vegetables. It is a starchy, sweettasting. They have a thin, brown skin on the outside with colored flesh inside –
        most commonly orange in color, but other varieties are white, purple or yellow
        </h5>

      </div>

      <hr />
      <hr />
      <h2 className='text-primary my-3'>Season:</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>  from July to March </h5>
        </li>


      </ul>
      <hr />
      <h2 className='text-primary my-3'>color:</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'> purple, white, orange</h5>
        </li>
      </ul>
      <hr />
      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>Varieties:</h5>
        <h5 className=' mt-3'>Beauregard
        </h5>
        <h5 className=' mt-3'> Belfon
        </h5>
      </div>
      <hr />
      <h2 className='text-primary my-3'>Packing</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>in 6 kgs net weight cartons</h5>

        </li>
      </ul>
      <hr />
      <h2 className='text-primary my-3'>Weight</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>150:800 gm</h5>

        </li>
      </ul>
      <hr />
      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>Size:</h5>
        <h5 className=' mt-3'>
        M , L1 , L2 , XL 
        </h5>
      </div>
      <hr />
      <hr />
      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
